import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { dispatchTrackingEvent, TrackingEvents } from "@jti/tracker";
import { useConfig } from "@jti/ui/providers/useConfig";
import { X_SELLING_POPUP_GTM_CTA_LOCATION } from "./const/tracking";
import { XSellingDialog } from "./components";
import { XSellingDialogEvents } from "./events";
const xSellingDialogModelDataToXSellingDialogProps = (modelData) => ({
    title: modelData.title,
    subtitle: modelData.subtitle,
    confirmButtonText: modelData.confirmButtonText,
    cancelButtonText: modelData.cancelButtonText,
    products: modelData.products,
});
export const XSellingDialogWrapper = (props) => {
    const { CART_CHECKOUT_PAGE_URL } = useConfig();
    const [isOpen, setIsOpen] = useState(false);
    useEffect(() => {
        const abortController = new AbortController();
        window.addEventListener(XSellingDialogEvents.open, () => setIsOpen(true), { signal: abortController.signal });
        return () => abortController.abort();
    }, []);
    const handleConfirmClick = async () => {
        await dispatchTrackingEvent(TrackingEvents.TrackingCtaClick, {
            cta_name: props.confirmButtonText,
            cta_location: X_SELLING_POPUP_GTM_CTA_LOCATION,
        });
        window.location.assign(props.confirmRedirectUrl);
    };
    const handleCloseClick = async () => {
        await dispatchTrackingEvent(TrackingEvents.TrackingCtaClick, {
            cta_name: props.cancelButtonText,
            cta_location: X_SELLING_POPUP_GTM_CTA_LOCATION,
        });
        window.location.assign(CART_CHECKOUT_PAGE_URL);
    };
    return (isOpen && (_jsx(XSellingDialog, { isOpened: isOpen, onClose: handleCloseClick, onConfirm: handleConfirmClick, ...xSellingDialogModelDataToXSellingDialogProps(props) })));
};
//# sourceMappingURL=XSellingDialogWrapper.js.map